import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-dialog wise-modal" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { for: "PurchaseOrderNbr" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cloud-arrow-down-fill" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["disabled", "placeholder"]
const _hoisted_11 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_12 = { for: "SupplierKey" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { value: "" }
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_17 = { for: "DateSent" }
const _hoisted_18 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_19 = { class: "modal-footer" }
const _hoisted_20 = { class: "d-flex justify-content-end" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{'d-none': !_ctx.visible}, "modal fade show"]),
    style: {"display":"block"}
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.windowTitle), 1),
          (!_ctx.isSavingRecord)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeFormRet && _ctx.closeFormRet(...args))),
                type: "button",
                class: "btn-close"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass(["col-md-12 form-group", {'has-error': _ctx.v$.dataRecord.PurchaseOrderNbr.$error}])
            }, [
              _createElementVNode("label", _hoisted_7, [
                _createTextVNode(_toDisplayString(_ctx.language.purch_order) + "  ", 1),
                _createElementVNode("a", {
                  href: "javascript:;",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.generatePurchaseNbr && _ctx.generatePurchaseNbr(...args)))
                }, _hoisted_9)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "PurchaseOrderNbr",
                class: "form-control capletter",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dataRecord.PurchaseOrderNbr) = $event)),
                disabled: _ctx.isSavingRecord || _ctx.dataRecord.IdPurchase != 0,
                placeholder: '(' + _ctx.language.purch_order.toLowerCase() + ')',
                maxlength: "15",
                autocomplete: "off",
                onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectOnFocus($event)))
              }, null, 40, _hoisted_10), [
                [_vModelText, _ctx.dataRecord.PurchaseOrderNbr]
              ]),
              (_ctx.v$.dataRecord.PurchaseOrderNbr.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.v$.dataRecord.PurchaseOrderNbr.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["col-md-12 form-group", {'has-error': _ctx.v$.dataRecord.SupplierKey.$error}])
            }, [
              _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.language.supplier), 1),
              _withDirectives(_createElementVNode("select", {
                id: "SupplierKey",
                name: "SupplierKey",
                class: "form-control-sel",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dataRecord.SupplierKey) = $event)),
                disabled: _ctx.isSavingRecord || _ctx.dataRecord.IdPurchase != 0
              }, [
                _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.language.select_supplier), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suppliers, (oSuppl) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: oSuppl.SupplierKey,
                    value: oSuppl.SupplierKey
                  }, _toDisplayString(oSuppl.SupplierName), 9, _hoisted_15))
                }), 128))
              ], 8, _hoisted_13), [
                [_vModelSelect, _ctx.dataRecord.SupplierKey]
              ]),
              (_ctx.v$.dataRecord.SupplierKey.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.v$.dataRecord.SupplierKey.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["col-md-12 form-group", {'has-error': !_ctx.isDateCorrect}])
            }, [
              _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.language.oper_date), 1),
              _createVNode(_component_Datepicker, {
                modelValue: _ctx.dataRecord.OperationDate,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dataRecord.OperationDate) = $event)),
                format: "dd/MM/yyyy",
                cancelText: _ctx.language.cancel,
                selectText: _ctx.language.select,
                disabled: _ctx.isSavingRecord || _ctx.dataRecord.IdPurchase != 0
              }, null, 8, ["modelValue", "cancelText", "selectText", "disabled"]),
              (!_ctx.isDateCorrect)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.language.errorDateBetween(_ctx.appFxs.formatDateFr(_ctx.firstDate), _ctx.appFxs.formatDateFr(_ctx.lastDate))), 1))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary me-2",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeFormRet && _ctx.closeFormRet(...args))),
              disabled: _ctx.isSavingRecord
            }, _toDisplayString(_ctx.language.close), 9, _hoisted_21),
            (_ctx.dataRecord.IdPurchase == 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.saveRecordData && _ctx.saveRecordData(...args))),
                  disabled: _ctx.v$.$invalid || !_ctx.isDateCorrect || _ctx.isSavingRecord
                }, [
                  (_ctx.isSavingRecord)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 0,
                        icon: ['fa', 'fa-spinner']
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.isSavingRecord)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 1,
                        icon: ['fa', 'fa-save']
                      }))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.language.save), 1)
                ], 8, _hoisted_22))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 2))
}